import React, { FunctionComponent, useContext } from 'react';
import LoadingRing from 'ui/atoms/loading-ring';
import WizardContext from 'libraries/wizard/wizard-context';
import Translate from 'ui/atoms/translate';
import ActionButtons from 'ui/molecules/action-buttons';
import Button from 'ui/atoms/button';
import InvestmentFinalSummary from 'subapps/investment/pages/investment/wizard-steps/final/Investment-final-summary';
import useGoTo from 'hooks/use-go-to';
import { INVESTOR_ROUTES } from 'apps/investor/pages/routes.config';
import WizardHeader from 'libraries/wizard/wizard-header';
import Header from 'ui/atoms/header';

const FinalStep: FunctionComponent<{}> = () => {
  const { token } = useContext(WizardContext);

  const goToDashboard = useGoTo(INVESTOR_ROUTES.overview);

  // TODO(mara-cashlink): error handling

  if (!token) {
    return <LoadingRing />;
  }

  return (
    <>
      <WizardHeader />
      <Header size="large" spacing="xlarge">
        <Translate name="accountCreationFinal.title" />
      </Header>
      <InvestmentFinalSummary />
      <ActionButtons>
        <Button variant="secondary" size="large" fluid={true} onClick={() => goToDashboard()}>
          <Translate name="investmentFinalSummary.toOverview" />
        </Button>
      </ActionButtons>
    </>
  );
};

export default FinalStep;
